<template>
  <div class="leave_setup">
    <div class="leave_setup__error" v-if="errorDiv"></div>

    <div class="leave_setup__loader" v-if="pageLoader">
      <div>
        <PageLoader />
      </div>
    </div>

    <div class="leave_setup__list" v-if="leaveList">
      <div class="leave_setup__list--btn">
        <div class="leave_setup__list--btn-text">
          Well-done; these are the leave types you have setup now:
        </div>
        <div class="leave_setup__list--btn-edit" @click="openEdit">
          Edit leave
        </div>
      </div>

      <div class="leave_setup__list--card">
        <div v-for="(leave, index) in leaveType" :key="index">
          <div>
            <div>
              <img
                src="../../../assets/images/man.svg"
                alt="leave.type"
                v-if="!leave.icon"
              />
              <img :src="leave.icon" alt="leave.type" v-if="leave.icon" />
            </div>
            <span>{{ leave.type }}</span>
            <p>Maximum days: {{ leave.maximum_days }}</p>
          </div>
        </div>
      </div>

      <div class="leave_setup__card--add" @click="addLeaveType">
        <font-awesome-icon icon="plus" />&nbsp;add more leave options
      </div>
    </div>

    <div class="leave_setup__card" v-if="leaveCard">
      <div class="leave_setup__card--header">
        <span>Lets Setup Your Leave</span>
        <p>Please answer the following questions.</p>
      </div>
      <div class="leave_setup__card--initial">
        <div>
          <p>Select who will be approving the leave?</p>
          <div>
            <select v-model="selectedApproval">
              <option value="0">Select Approval</option>
              <option
                v-for="staff in employeeList"
                :key="staff.id"
                :value="staff.user_id"
              >
                {{ staff.user.firstname }} {{ staff.user.lastname }}
              </option>
            </select>
          </div>

          <p>Should HR approve leave?</p>
          <div>
            <select v-model="hrApproval">
              <option value="1">Yes</option>
              <option value="0">No</option>
            </select>
          </div>

          <div>
            <button @click="setupLeave" v-if="!approvalLoader">Submit</button>
            <button disabled="disable" v-if="approvalLoader">
              <WhiteLoader />
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="leave_setup__edit" v-if="leaveEdit">
      <div class="leave_setup__edit-cards">
        <div v-for="(leave, index) in leaveType" :key="index">
          <div class="leave_setup--opt">
            <div
              class="leave_setup--opt-remove"
              v-if="
                leave.type !== 'Sick Leave' &&
                leave.type !== 'Casual Leave' &&
                leave.type !== 'Annual Leave'
              "
            >
              <span @click="deleteLeave(leave.id)">
                <font-awesome-icon icon="trash-alt" />&nbsp; Remove leave option
              </span>
            </div>
            <div
              class="leave_setup--opt-edit"
              v-if="
                leave.type !== 'Sick Leave' &&
                leave.type !== 'Casual Leave' &&
                leave.type !== 'Annual Leave'
              "
            >
              <span> <font-awesome-icon icon="edit" />&nbsp;edit </span>
            </div>
          </div>
          <div class="leave_setup--card">
            <label>Name of Leave:</label>
            <input type="text" v-model="leave.type" />

            <br />
            <label>Maximum Days Allowed.:</label>
            <input type="number" v-model="leave.maximum_days" />
          </div>
        </div>
      </div>

      <div class="leave_setup__edit-btn">
        <div @click="cancelEdit">Cancel</div>
      </div>
    </div>

    <div class="leave_setup__modal" v-if="modal">
      <div>
        <div>
          <p>
            <span @click="closeLeaveModal">
              <font-awesome-icon icon="times" />
            </span>
          </p>
          <label>Name of Leave</label>
          <input type="text" v-model="newLeaveType" />

          <label class="mt-25">Maximum Days Allowed:</label>
          <input type="number" v-model="newMaxDay" />

          <button @click="setLeaveType" v-if="!newLeaveTypeLoader">Save</button>
          <button disabled="disable" v-if="newLeaveTypeLoader">
            <WhiteLoader />
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as types from "../../../store/constant";
import PageLoader from "../../partials/page-loader";
import WhiteLoader from "../../partials/white-loader";

export default {
  name: "LeaveSetup",
  components: {
    PageLoader,
    WhiteLoader,
  },
  data() {
    return {
      selectedApproval: "0",
      hrApproval: "1",
      leaveOptions: false,
      leaveOption: [
        {
          name: "",
          days: "",
        },
      ],

      pageLoader: true,
      leaveCard: false,
      leaveList: false,
      leaveEdit: false,
      leaveType: [],
      modal: false,
      newLeaveType: "",
      newMaxDay: "",
      newLeaveTypeLoader: false,
      approvalLoader: false,
      errorDiv: false,
      errorMessage: null,
      employeeList: [],
    };
  },
  created() {
    this.getEmployees();
  },
  methods: {
    getEmployees() {
      this.$http
        .get(types.GET_ALL_EMPLOYEES_API)
        .then((resp) => {
          const data = resp.data.data;
          this.employeeList = [...data];
          this.checkoutSetup();
        })
        .catch((err) => {
          this.errorDiv = true;
          this.errorMessage = "Server error, Please try again later.";
        });
    },

    checkoutSetup() {
      this.errorDiv = false;
      this.errorMessage = null;
      this.pageLoader = true;
      this.$http
        .get(types.LEAVE_SETTING)
        .then((resp) => {
          const data = resp.data.data;

          if (data) {
            this.getLeaveType();
          } else {
            this.leaveCard = true;
            this.leaveList = false;
            this.leaveEdit = false;
            this.pageLoader = false;
          }
        })
        .catch((err) => {
          this.errorDiv = true;
          this.errorMessage = "Server error, Please try again later.";
        });
    },

    setupLeave() {
      this.errorDiv = false;
      this.errorMessage = null;

      if (this.selectedApproval === "0") {
        this.errorDiv = true;
        this.errorMessage = "Please select who to approve leave request.";
        return;
      }

      this.approvalLoader = true;

      const constSaveLeave = {
        approval: this.selectedApproval,
        manager_approve: this.hrApproval,
      };

      this.$http
        .post(types.LEAVE_SETTING, constSaveLeave)
        .then((resp) => {
          this.getLeaveType();
        })
        .catch((err) => {
          this.errorDiv = true;
          this.errorMessage = "Server error, Please try agian later.";
          this.approvalLoader = false;
        });
    },

    getLeaveType() {
      this.errorDiv = false;
      this.errorMessage = null;

      this.$http
        .get(types.LEAVE_TYPE)
        .then((resp) => {
          this.leaveType = [...resp.data.data];

          this.leaveList = true;
          this.leaveCard = false;
          this.leaveEdit = false;
          this.approvalLoader = false;
          this.pageLoader = false;
        })
        .catch((err) => {
          this.errorDiv = true;
          this.errorMessage = "Server error, Please try agian later.";
        });
    },

    setLeaveType(e) {
      e.preventDefault();

      this.errorDiv = false;
      this.errorMessage = null;

      if (this.newLeaveType.trim() === "") {
        return;
      }

      this.newLeaveTypeLoader = true;

      const leaveList = [];

      for (let index = 0; index < this.leaveType.length; index++) {
        leaveList.push({
          name: this.leaveType[index].type,
        });
      }

      leaveList.push({
        name: this.newLeaveType,
        max_days: this.newMaxDay,
      });

      this.$http
        .post(types.LEAVE_TYPE, {
          leave_types: [...leaveList],
        })
        .then((resp) => {
          this.leaveType = [...resp.data.data];
          this.modal = false;
          this.newLeaveTypeLoader = false;
          this.newLeaveType = "";
          this.newMaxDay = "";
        })
        .catch((err) => {
          this.errorDiv = true;
          this.errorMessage = "Server error, Please try agian later.";
        });
    },
    addLeaveType() {
      this.modal = true;
    },
    closeLeaveModal() {
      this.modal = false;
    },
    openEdit() {
      this.leaveList = false;
      this.leaveCard = false;
      this.leaveEdit = true;
      this.pageLoader = false;
    },

    deleteLeave(val) {
      this.errorDiv = false;
      this.errorMessage = null;

      this.leaveList = false;
      this.leaveCard = false;
      this.leaveEdit = false;
      this.pageLoader = true;

      this.$http
        .delete(types.LEAVE_TYPE, {
          data: {
            leave_type_id: val,
          },
        })
        .then((resp) => {
          this.leaveType = [...resp.data.data];

          this.leaveList = false;
          this.leaveCard = false;
          this.leaveEdit = true;
          this.pageLoader = false;
        })
        .catch((err) => {
          this.errorDiv = true;
          this.errorMessage = "Server error, Please try agian later.";
        });
    },
    cancelEdit() {
      this.leaveCard = false;
      this.leaveList = true;
      this.leaveEdit = false;
      this.pageLoader = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.mt-25 {
  margin-top: 25px;
}
.leave_setup {
  padding: 20px 0 100px 0;

  > .leave_setup__error {
    border: 1px solid red;
    margin-bottom: 10px;
    padding: 10px;
    background-color: rgba(255, 0, 0, 0.4);
    color: #fff;
    font-size: 14px;
    text-align: left;
  }

  > .leave_setup__loader {
    > div {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      align-items: center;
      justify-content: center;
      align-content: center;
    }
  }

  > .leave_setup__list {
    > .leave_setup__list--btn {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      align-items: center;
      justify-content: center;
      align-content: center;
      margin-bottom: 50px;

      > .leave_setup__list--btn-text {
        width: calc(100% - 100px);
        font-size: 14px;
        text-align: left;
        color: #000;
      }

      > .leave_setup__list--btn-edit {
        width: 100px;
        width: 100px;
        background-color: #5099de;
        border-radius: 5px;
        padding: 10px 0;
        text-align: center;
        color: #fff;
        font-size: 14px;
        cursor: pointer;
      }
    }
    > .leave_setup__list--card {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      align-items: center;
      justify-content: flex-start;
      align-content: center;

      > div {
        width: 33.333333333%;
        padding: 10px 20px;

        > div {
          border-radius: 5px;
          box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
          background-color: #fff;
          padding: 20px;

          > div {
            width: 50px;
            height: 50px;
            overflow: hidden;
            margin-bottom: 20px;

            > img {
              width: 100%;
            }
          }

          > span {
            font-size: 16px;
            font-weight: 600;
            font-stretch: normal;
            font-style: normal;
            line-height: 0.75;
            letter-spacing: normal;
            text-align: center;
            color: #000000;
          }

          > p {
            font-size: 14px;
            font-weight: 300;
            font-stretch: normal;
            font-style: normal;
            line-height: 0.75;
            letter-spacing: normal;
            text-align: left;
            color: #000000;
            margin-top: 10px;
          }
        }
      }
    }

    > .leave_setup__card--add {
      width: 80%;
      margin: 20px auto 0 auto;
      text-align: center;
      font-size: 14px;
      font-weight: 200;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.67;
      letter-spacing: normal;
      color: #000;
      background-color: #fff;
      padding: 10px 0;
      border: 1px dashed #5099de;
      cursor: pointer;
    }
  }

  > .leave_setup__card {
    padding: 30px 0 100px 0;

    > .leave_setup__card--header {
      text-align: center;

      > span {
        font-size: 24px;
        font-weight: 600;
        font-stretch: normal;
        font-style: normal;
        line-height: 0.75;
        letter-spacing: normal;
        text-align: center;
        color: #000000;
      }

      > p {
        font-size: 16px;
        font-weight: 200;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.67;
        letter-spacing: normal;
        text-align: center;
        color: #000000;
        margin: 10px 0 0 0;
      }

      > div {
        width: 200px;
        margin: 20px auto;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: center;
        align-content: center;

        > .leave_setup__card--header-left {
          width: 50px;
          height: 50px;
          border-radius: 100%;
          border: solid 1px #5099de;
          background-color: #5099de;
          font-size: 14px;
          font-weight: 600;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.5;
          letter-spacing: normal;
          color: #fff;
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          align-items: center;
          justify-content: center;
          align-content: center;
        }

        > .leave_setup__card--header-middle {
          width: 100px;
          height: 2px;
          border: solid 1px #5099de;
        }

        > .leave_setup__card--header-right {
          width: 50px;
          height: 50px;
          border-radius: 100%;
          border: solid 1px #5099de;
          background-color: #ffffff;
          font-size: 14px;
          font-weight: 600;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.5;
          letter-spacing: normal;
          color: #000;
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          align-items: center;
          justify-content: center;
          align-content: center;
        }
      }
    }

    .leave_setup__card--initial {
      margin-top: 30px;

      > div {
        > p {
          font-size: 16px;
          font-weight: 200;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.67;
          letter-spacing: normal;
          text-align: center;
          color: #000000;
          margin-bottom: 5px;
        }

        > div {
          width: 200px;
          margin: auto;
          margin-bottom: 30px;
          position: relative;

          > div {
            position: absolute;
            top: 0;
            left: 205px;
            width: 150px;
            height: 40px;
            font-size: 12px;
            font-weight: 200;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.82;
            letter-spacing: normal;
            text-align: left;
            color: #000000;
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            align-items: center;
            justify-content: flex-start;
            align-content: center;
            font-style: italic;
          }
          > select {
            border-radius: 5px;
            border: solid 1px #cecece;
            background-color: #ffffff;
            outline: 0;
            width: 100%;
            height: 40px;
            font-size: 14px;
            font-weight: 200;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.67;
            letter-spacing: normal;
            text-align: center;
            color: #000000;
          }

          > button {
            width: 100px;
            height: 40px;
            border-radius: 2px;
            background-color: #5099de;
            font-size: 12px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: 2.9;
            letter-spacing: normal;
            color: #ffffff;
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            align-items: center;
            justify-content: center;
            align-content: center;
            margin: auto;
            border: 0;
            outline: 0;
          }
        }
      }
    }

    .leave_setup__card--final {
      > .leave_setup__card--cards {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        align-items: center;
        justify-content: flex-start;
        align-content: center;

        > div {
          width: 33.333333333%;
          padding: 10px;

          > div {
            background-color: #fff;
            padding: 20px;
            box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
            border-radius: 5px;
            > p {
              text-align: right;
              > span {
                font-size: 12px;
                font-weight: 200;
                font-stretch: normal;
                font-style: normal;
                line-height: 1.67;
                letter-spacing: normal;
                color: red;
                cursor: pointer;
              }
            }

            > div {
              > label {
                font-size: 14px;
                font-weight: 200;
                font-stretch: normal;
                font-style: normal;
                line-height: 1.67;
                letter-spacing: normal;
                text-align: left;
                color: #000;
              }

              > input {
                height: 40px;
                border: 1px solid #ccc;
                outline: 0;
                font-size: 14px;
                font-weight: 200;
                font-stretch: normal;
                font-style: normal;
                line-height: 1.67;
                letter-spacing: normal;
                text-align: left;
                color: #000;
                padding: 0 5px;
                margin-bottom: 20px;
              }
            }
          }
        }
      }

      > .leave_setup__card--add {
        width: 80%;
        margin: 20px auto 0 auto;
        text-align: center;
        font-size: 14px;
        font-weight: 200;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.67;
        letter-spacing: normal;
        color: #000;
        background-color: #fff;
        padding: 10px 0;
        border: 1px dashed #5099de;
        cursor: pointer;
      }

      > .leave_setup__card--btn {
        margin: 20px 0;

        > div {
          width: 100px;
          height: 40px;
          background-color: #5099de;
          font-size: 14px;
          font-weight: 200;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.67;
          letter-spacing: normal;
          color: #fff;
          margin: auto;
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          align-items: center;
          justify-content: center;
          align-content: center;
          border-radius: 5px;
          cursor: pointer;
        }
      }
    }
  }

  > .leave_setup__edit {
    > .leave_setup__edit-cards {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      align-items: center;
      justify-content: flex-start;
      align-content: center;
      > div {
        width: 33.333333333%;
        padding: 10px;
        margin-bottom: 20px;

        > .leave_setup--opt {
          padding: 5px;
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          align-items: center;
          justify-content: center;
          align-content: center;
          min-height: 30px;

          > .leave_setup--opt-remove {
            width: 60%;
            font-size: 12px;
            color: red;
            > span {
              cursor: pointer;
            }
          }

          > .leave_setup--opt-edit {
            width: 40%;
            text-align: right;
            font-size: 12px;
            color: #ccc;
            > span {
              cursor: pointer;
            }
          }
        }

        > .leave_setup--card {
          box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
          background-color: #fff;
          padding: 10px;
          margin-top: 10px;

          > label {
            font-size: 14px;
            text-align: left;
            color: #000;
          }
          > input {
            height: 40px;
            border: 1px solid #000;
            outline: 0;
            font-size: 14px;
            color: #000;
            padding: 0 5px;
          }
        }
      }
    }

    > .leave_setup__edit-btn {
      > div {
        width: 100px;
        margin: auto;
        padding: 10px 0;
        border: 0;
        outline: 0;
        background-color: #5099de;
        color: #fff;
        text-align: center;
        border-radius: 5px;
        margin-top: 10px;
        font-size: 14px;
        cursor: pointer;
      }
    }
  }

  .leave_setup__modal {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.4);
    overflow: auto;

    > div {
      padding: 0 10px;
      margin: 100px auto;
      max-width: 400px;

      > div {
        background-color: #fff;
        padding: 20px;
        border-radius: 5px;

        > p {
          text-align: right;

          > span {
            color: #000;
            font-size: 12px;
            cursor: pointer;
          }
        }

        > label {
          text-align: left;
          font-size: 14px;
          color: #000;
        }

        > input {
          height: 40px;
          border: 1px solid #000;
          outline: 0;
          font-size: 14px;
          padding: 0 5px;
          border-radius: 5px;
        }

        > button {
          height: 40px;
          border: 0;
          outline: 0;
          background-color: #5099de;
          color: #fff;
          text-align: center;
          border-radius: 5px;
          margin-top: 10px;
          font-size: 14px;
        }
      }
    }
  }
}
</style>
